export var ErrorMessage;
(function (ErrorMessage) {
    ErrorMessage["ImageRemovedDuringLoad"] = "Image was removed while loading";
    ErrorMessage["ImageLoadingFailed"] = "Could not load image";
    ErrorMessage["ResizeObservableLoopLimit"] = "ResizeObserver loop limit exceeded";
    ErrorMessage["ResizeObservableLoopCompleted"] = "ResizeObserver loop completed with undelivered notifications";
    ErrorMessage["VideoSourceInitFailed"] = "Failed to initialize video source";
    ErrorMessage["MediaErrorAborted"] = "media resource fetching was aborted";
    ErrorMessage["MediaErrorNetwork"] = "a network error occurred while fetching the media resource";
    ErrorMessage["MediaErrorDecode"] = "error occurred while decoding the media resource";
    ErrorMessage["MediaErrorSourceNotSupported"] = "media resource is not supported";
    ErrorMessage["FeedDataFetchNetworkError"] = "Could not fetch feed data: TypeError: Failed to fetch";
})(ErrorMessage || (ErrorMessage = {}));
